import React, { useEffect } from 'react';
import { ThemeProvider, CssBaseline, Container, Box } from '@mui/material';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from 'react-router-dom';
import theme from './theme';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import PostalSearchPage from './pages/PostalSearchPage';
import ReverseSearchPage from './pages/ReverseSearchPage';
import BrowsePage from './pages/BrowsePage';
import ApiDocsPage from './pages/ApiDocsPage';
import AboutPage from './pages/AboutPage';
import { pushEvent } from './utils/analytics';
import './App.css';

function Layout() {
  const location = useLocation();

  // page_view on every route change (and initial load).
  useEffect(() => {
    pushEvent('page_view', { page_path: location.pathname });
  }, [location.pathname]);

  const showFooter = !['/api-docs', '/about'].includes(location.pathname);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <NavBar />
      <Container component="main" maxWidth="md" sx={{ flex: 1, py: 4, width: '100%' }}>
        <Routes>
          <Route path="/" element={<PostalSearchPage />} />
          <Route path="/reverse" element={<ReverseSearchPage />} />
          <Route path="/browse" element={<BrowsePage />} />
          <Route path="/api-docs" element={<ApiDocsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Container>
      {showFooter && <Footer />}
    </Box>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Layout />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
